import {Component, OnDestroy, OnInit} from "@angular/core";
import {UtilsService} from "../../../../../core/utils/utils.service";
import {ProduitDeclinaisonService} from "../../../../../core/services/entities/produit-declinaison.service";
import {ProduitDeclinaisonDTO} from "../../../../../core/dtos/produit-declinaison-dto";
import {Subscription} from "rxjs/index";
import {UniteDeMesureDTO} from "../../../../../core/dtos/unitedemesure-dto";
import {UnitesDeMesuresService} from "../../../../../core/services/entities/unites-de-mesures.service";
import {ResponseWrapper} from "../../../../../core/suppliers/wrappers/response-wrapper";
import {DialogMsgSupplier, Paragraphe} from "../../../../../core/suppliers/dialog-msg-supplier";
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from "../../../../../core/constants";
import {ToastService} from "../../../../../core/services/technique/toast.service";
import notify from "devextreme/ui/notify";
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-dialog-change-unite-technique',
    templateUrl: './dialog-change-unite-technique.component.html',
    styleUrls: ['./dialog-change-unite-technique.component.scss'],
    standalone: false
})
export class DialogChangeUniteTechniqueComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  displayDialog: boolean = false;
  denree: ProduitDeclinaisonDTO;
  pourcentageSubstitution: number = 100;

  uniteTechniqueSubstitution: UniteDeMesureDTO;

  subInitDialog: Subscription;

  uniteDeMesureList: UniteDeMesureDTO[] = [];
  qteOldUnitedeMesure: number;
  qteNewUniteDeMesure: number;

  pathFile: string = HELP_FOLDERS.PRODUITS + '/produits-declinaison-changement-unite-technique';

  constructor(public utils: UtilsService,
              private produitDeclinaisonSvc: ProduitDeclinaisonService,
              private uniteDeMesureSvc: UnitesDeMesuresService,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.subcriptionInitDialog();
  }

  ngOnDestroy() {
    this.utils.unsubscribe(this.subInitDialog);
  }

  subcriptionInitDialog = () => {
    this.subInitDialog = this.produitDeclinaisonSvc.openDialogChangeUniteTechnique$.subscribe(data => {
      this.denree = data;
      this.displayDialog = true;
    });
    this.uniteDeMesureSvc.getAllUniteDeMesure().subscribe((data: ResponseWrapper<UniteDeMesureDTO>) => {
      this.uniteDeMesureList = data.resultList
    });
  };

  closeDialog = () => {
    this.displayDialog = false;
  };

  help = () => {

    let dms = new DialogMsgSupplier();
    dms.title = `Changement de l'unité technique `;
    dms.logo = 'fa fa-question-circle  yoni-color';


    let p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [
      `Cette action va permettre de changer l'unité technique d'une denrée.`,
      `Ce changement  aura un impact sur la recette d'un plat utilisant cette denrée`,
      `Le grammage de la recette ne va pas changer. Mais le nombre d'unité technique `,
      `utilisé necessaire pour réaliser la recette  peut changer en fonction du `,
      `pourcentage de subtitution.`
    ];


    dms.content = {
      intro: `Unité technique`,
      paragraphes: [p1]

    };

    return dms;
  };

  saveUniteTechnique = () => {
    this.produitDeclinaisonSvc.saveChangeUniteTechnique(this.denree.id,
      this.uniteTechniqueSubstitution.id,
      this.qteOldUnitedeMesure,
      this.qteNewUniteDeMesure).subscribe((data: ResponseWrapper<any>) => {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS,
        `Le changement d'unité technique a été réalisé avec succès. Son changement a impacté ${data.one?.dishesWichUsedCurrentFoodStuff.length} recette(s)`);
      this.produitDeclinaisonSvc.announceNewUniteTechnique(data.one);
      this.closeDialog();
      if (!this.denree.fabrique)
        notify({message: "Pensez à mettre à jour votre stock minimum", width: "auto", position: 'bottom-right'});
    });
  };

  onSelectionChanged = (event: any) => {
    this.uniteTechniqueSubstitution = event.selectedRowsData[0];
    this.qteNewUniteDeMesure = 0;
  };

  getMesureForOldUniteDeMesure = () => {
    if (this.pourcentageSubstitution <= 0 ||
      this.denree.ratioUniteTechnique <= 0) {
      return 0;
    } else {
      this.qteOldUnitedeMesure = this.denree.ratioUniteTechnique;
      return this.qteOldUnitedeMesure;
    }
  };

  getMesureForNewUniteDeMesure = () => {
    if (this.pourcentageSubstitution <= 0 ||
      this.denree.ratioUniteTechnique <= 0) {
      return 0;
    } else {
      return (this.qteOldUnitedeMesure * (this.pourcentageSubstitution / 100));
    }
  };
}
